import { MessageItemLevel } from './message-center.model';

const INVALID = { level: undefined, id: undefined, code: undefined, valid: false };

export function getComposedParams(composition: string): {
  level: MessageItemLevel;
  id: number;
  code: string;
  valid: boolean;
} {
  try {
    if (composition === '' || composition == null) {
      return INVALID;
    }

    const extractions = composition.split('.');

    if (extractions.length !== 3) {
      return INVALID;
    }

    const level = MessageItemLevel[extractions[0]];

    if (level == null) {
      return INVALID;
    }
    const id = Number(extractions[1]);

    if (isNaN(id)) {
      return INVALID;
    }

    const code = extractions[2];

    if (code === '' || code == null) {
      return INVALID;
    }

    return { level, id, code, valid: true };
  } catch {
    return INVALID;
  }
}
